/*************************************************/
/* MAP                                           */
/*************************************************/
export function map() {
    const mapMarkers = document.querySelectorAll('.map__map-marker');
    const markerInfos = document.querySelectorAll('.map__map-marker-info');
    const accordionItems = document.querySelectorAll('.accordion__item[data-country]');
    const activeClass = 'accordion__item--active';
    const mapContainer = document.querySelector('.map__map');

    mapMarkers.forEach(marker => {
        marker.addEventListener('click', event => {
            const clickedMarker = event.target;
            const country = clickedMarker.dataset.country;
            const accordionItem = document.querySelector(`.accordion__item[data-country="${country}"]`);

            if (accordionItem && !accordionItem.classList.contains(activeClass)) {
                const accordionHead = accordionItem.querySelector('.accordion__item-head');
                accordionHead.click();
            }
            event.stopPropagation();
        });

        marker.addEventListener('mouseover', event => {
            const hoveredMarker = event.target;
            const markerInfo = hoveredMarker.nextElementSibling;

            markerInfos.forEach(info => {
                const isInfoVisible = info === markerInfo;
                info.classList.toggle('show', isInfoVisible);

                if (isInfoVisible) {
                    const markerRect = marker.getBoundingClientRect();
                    const mapContainerRect = mapContainer.getBoundingClientRect();
                    const markerLeft = markerRect.left - mapContainerRect.left;

                    // Retrieve the stored tooltipWidth or calculate and store it
                    const tooltip = info;
                    let tooltipWidth = tooltip.getAttribute('data-tooltip-width');
                    if (!tooltipWidth) {
                        tooltipWidth = tooltip.offsetWidth;
                        tooltip.setAttribute('data-tooltip-width', tooltipWidth);
                    }

                    const rightEdgeThreshold = mapContainerRect.width - tooltipWidth;

                    if (markerLeft > rightEdgeThreshold) {
                        tooltip.style.left = markerLeft - tooltipWidth + 'px';
                        info.classList.add('before-right');

                        const beforeElement = document.querySelector('.before-right');
                        var t = `calc(10% + 250px)`;
                        beforeElement.style.setProperty('--before-pseudo-left', t);
                    }
                }
            });
        });

        marker.addEventListener('mouseleave', () => {
            markerInfos.forEach(info => {
                info.classList.remove('show');
                info.classList.remove('before-right');
            });
        });
    });
}